(() => {
let $e8de77a7e14f36ab$var$currentlyExpanding = null;
function $e8de77a7e14f36ab$export$2e2bcd8739ae039() {
    const accordionElements = document.querySelectorAll('[ck-accordion]');
    accordionElements.forEach((accordion, index)=>{
        const button = accordion.querySelector('button');
        const content = button?.nextElementSibling;
        if (!button || !content) return;
        $e8de77a7e14f36ab$var$ensureAriaControlsAndID(button, content, index);
        $e8de77a7e14f36ab$var$setInitialState(button, content);
        button.addEventListener('click', ()=>$e8de77a7e14f36ab$var$toggleAccordion(button, content));
    });
}
/**
 * Sets the initial state for the accordion.
 *
 * @param button - The button element of the accordion section.
 * @param content - The content element of the accordion section.
 */ const $e8de77a7e14f36ab$var$setInitialState = (button, content)=>{
    button.setAttribute('aria-expanded', 'false');
    content.setAttribute('aria-hidden', 'true');
    content.style.maxHeight = '0';
};
/**
 * Toggles the accordion open or closed.
 *
 * @param button - The button element of the accordion section.
 * @param content - The content element of the accordion section.
 */ const $e8de77a7e14f36ab$var$toggleAccordion = (button, content)=>{
    const isExpanded = button.getAttribute('aria-expanded') === 'true';
    const accordionGroup = button.closest('[ck-accordion-group]');
    const closeAllExcept = (exceptionAccordion)=>{
        accordionGroup?.querySelectorAll('[ck-accordion]').forEach((otherAccordion)=>{
            if (otherAccordion !== exceptionAccordion) {
                const otherButton = otherAccordion.querySelector('button');
                const otherContent = otherButton?.nextElementSibling;
                if (otherButton && otherContent) $e8de77a7e14f36ab$var$collapseAccordion(otherButton, otherContent);
            }
        });
    };
    if (accordionGroup) {
        if (!isExpanded) {
            closeAllExcept(button.parentElement);
            $e8de77a7e14f36ab$var$expandAccordion(button, content);
        } else closeAllExcept(null);
    } else isExpanded ? $e8de77a7e14f36ab$var$collapseAccordion(button, content) : $e8de77a7e14f36ab$var$expandAccordion(button, content);
};
/**
 * Collapses the accordion section.
 *
 * @param button - The button element of the accordion section.
 * @param content - The content element of the accordion section.
 */ const $e8de77a7e14f36ab$var$collapseAccordion = (button, content)=>{
    if ($e8de77a7e14f36ab$var$currentlyExpanding === content) $e8de77a7e14f36ab$var$currentlyExpanding = null;
    const onTransitionEnd = ()=>{
        if (content !== $e8de77a7e14f36ab$var$currentlyExpanding) content.style.display = 'none';
        content.removeEventListener('transitionend', onTransitionEnd);
    };
    content.addEventListener('transitionend', onTransitionEnd);
    content.style.maxHeight = '0';
    button.setAttribute('aria-expanded', 'false');
    content.setAttribute('aria-hidden', 'true');
};
/**
 * Expands the accordion section.
 *
 * @param button - The button element of the accordion section.
 * @param content - The content element of the accordion section.
 */ const $e8de77a7e14f36ab$var$expandAccordion = (button, content)=>{
    $e8de77a7e14f36ab$var$currentlyExpanding = content;
    $e8de77a7e14f36ab$var$clearTransitionEndListeners(content);
    content.style.display = 'block';
    const contentHeight = content.scrollHeight;
    content.style.maxHeight = `${contentHeight}px`;
    button.setAttribute('aria-expanded', 'true');
    content.setAttribute('aria-hidden', 'false');
};
/**
 * Ensures the ARIA controls and ID requirements are set correctly.
 * If the content element doesn't have an ID, it assigns a unique one based on the index.
 * If the button element doesn't have an aria-controls attribute or it doesn't match the content's ID, it sets the aria-controls attribute.
 * 
 * @param button - The button element of the accordion section.
 * @param content - The content element of the accordion section.
 * @param index - The index of the accordion section.
 */ const $e8de77a7e14f36ab$var$ensureAriaControlsAndID = (button, content, index)=>{
    content.id = content.id || `accordion-content-${index}`;
    button.setAttribute('aria-controls', content.id);
};
/**
 * Clears any pending transitionend event listeners.
 *
 * @param content - The content element of the accordion section.
 */ const $e8de77a7e14f36ab$var$clearTransitionEndListeners = (content)=>{
    const dummyFunc = ()=>{};
    content.removeEventListener('transitionend', dummyFunc);
};


/**
 * Checks if a specified component is an actual dialog.
 * @param {HTMLElement} component - The component to check.
 * @returns {HTMLDialogElement | null} The dialog element if it exists and is an instance of HTMLDialogElement; otherwise, null.
 */ const $e7f9d3ea50c2560b$var$getActualDialog = (component)=>{
    const dialog = component.querySelector('[ck-dialog]');
    return dialog && dialog instanceof HTMLDialogElement ? dialog : null;
};
/**
 * Checks if a specified component has a ck-dialog-video-src attribute
 * @param component - The component to check.
 * @returns { HTMLElement | null}
 */ const $e7f9d3ea50c2560b$var$getVideo = (component)=>{
    const video = component.querySelector('[ck-dialog-video-src]');
    return video ? video : null;
};
/**
 * Closes a specified dialog.
 * @param {HTMLElement} component - The component containing the dialog needing to be closed.
 */ const $e7f9d3ea50c2560b$var$closeDialog = (component)=>{
    const dialog = $e7f9d3ea50c2560b$var$getActualDialog(component);
    const video = $e7f9d3ea50c2560b$var$getVideo(component);
    if (dialog) {
        dialog.close();
        component.classList.remove('open');
        if (video) {
            // Save the current src before clearing it
            const currentSrc = video.getAttribute('src') || '';
            if (currentSrc) video.setAttribute('ck-dialog-video-src', currentSrc);
            video.setAttribute('src', '');
        }
    }
};
/**
 * Handles clicks outside of the dialog.
 * @param {Event} event - The click event.
 */ const $e7f9d3ea50c2560b$var$handleOutsideClick = (event)=>{
    const thisComponent = event.target.closest('[ck-dialog-component]');
    if (!thisComponent) return;
    const dialog = $e7f9d3ea50c2560b$var$getActualDialog(thisComponent);
    if (dialog && dialog.open) {
        const dialogBoundary = dialog.getBoundingClientRect();
        const clickedInside = event.clientX >= dialogBoundary.left && event.clientX <= dialogBoundary.right && event.clientY >= dialogBoundary.top && event.clientY <= dialogBoundary.bottom;
        if (!clickedInside) $e7f9d3ea50c2560b$var$closeDialog(thisComponent);
    }
};
/**
 * Attaches click listeners to all elements with [ck-dialog-open="id"].
 * Where "id" matches a particular dialog component's id.
 */ const $e7f9d3ea50c2560b$var$attachOpenDialogListeners = ()=>{
    const components = document.querySelectorAll('[ck-dialog-component]');
    const dialogOpeners = document.querySelectorAll('[ck-dialog-open]');
    dialogOpeners.forEach((dialogOpener)=>{
        const targetDialogId = dialogOpener.getAttribute('ck-dialog-open');
        components.forEach((component)=>{
            const dialog = $e7f9d3ea50c2560b$var$getActualDialog(component);
            const video = $e7f9d3ea50c2560b$var$getVideo(component);
            if (dialog && component.id === targetDialogId) dialogOpener.addEventListener('click', ()=>{
                if (dialog.getAttribute('ck-dialog-non-modal')) {
                    dialog.show();
                    setTimeout(()=>{
                        document.body.style.overflow = 'visible';
                    }, 300);
                } else dialog.showModal();
                document.body.style.overflow = 'hidden';
                component.classList.add('open');
                document.addEventListener('click', $e7f9d3ea50c2560b$var$handleOutsideClick);
                if (video) {
                    const savedSrc = video.getAttribute('ck-dialog-video-src');
                    const currentSrc = video.getAttribute('src');
                    // Determine which source to use
                    let videoSrc = '';
                    if (currentSrc && currentSrc.includes('youtube')) videoSrc = currentSrc + '?&autoplay=1&mute=0';
                    else if (!currentSrc && savedSrc) videoSrc = savedSrc;
                    else videoSrc = currentSrc || '';
                    video.setAttribute('src', videoSrc);
                }
            });
        });
    });
};
function $e7f9d3ea50c2560b$export$2e2bcd8739ae039() {
    const components = document.querySelectorAll('[ck-dialog-component]');
    components.forEach((component)=>{
        const dialog = $e7f9d3ea50c2560b$var$getActualDialog(component);
        if (dialog) {
            const closeButtons = component.querySelectorAll('[ck-dialog-close]');
            closeButtons.forEach((closeButton)=>{
                closeButton.addEventListener('click', ()=>$e7f9d3ea50c2560b$var$closeDialog(component));
            });
            dialog.addEventListener('close', ()=>{
                document.body.style.overflow = '';
                component.classList.remove('open');
                document.removeEventListener('click', $e7f9d3ea50c2560b$var$handleOutsideClick);
            });
        }
    });
    $e7f9d3ea50c2560b$var$attachOpenDialogListeners();
}


/**
 * Function to convert an HTML element to a different tag type while keeping the same attributes and children.
 *
 * @param {HTMLElement} el - The original HTML element that will be converted.
 * @param {string} tag - The new tag type the original element will be converted to.
 * @returns {HTMLElement} The new HTML element with the specified tag, attributes and children of the original element.
 */ const $3725beb56f0bb89d$export$64d8551c266151 = (el, tag)=>{
    const newElement = document.createElement(tag);
    newElement.innerHTML = el.innerHTML;
    Array.from(el.attributes).forEach((attr)=>{
        newElement.setAttribute(attr.name, attr.value);
    });
    el.parentNode?.replaceChild(newElement, el);
    return newElement;
};
const $3725beb56f0bb89d$export$9bb0e144ba4929ca = (el, placeFocusBefore)=>{
    let focusMethod, ogti, tempEl;
    const onblurEl = function(_e) {
        if (el.getAttribute('data-ogti') && ogti) el.setAttribute('tabindex', ogti);
        else el.removeAttribute('tabindex');
        el.removeAttribute('data-ogti');
        el.removeEventListener('focusout', focusMethod);
    };
    const onblurTempEl = function(_e) {
        tempEl.removeEventListener('focusout', focusMethod);
        tempEl.parentNode?.removeChild(tempEl);
    };
    const focusEl = function(theEl) {
        theEl.setAttribute('tabindex', '-1');
        theEl.addEventListener('focusout', focusMethod);
        theEl.focus();
    };
    focusMethod = onblurEl;
    if (placeFocusBefore) {
        tempEl = document.createElement('span');
        if (typeof placeFocusBefore === 'string') tempEl.innerHTML = placeFocusBefore;
        tempEl.setAttribute('style', 'position: absolute;height: 1px;width: 1px;margin: -1px;padding: 0;overflow: hidden;clip: rect(0 0 0 0);border: 0;');
        const newEl = el.parentNode?.insertBefore(tempEl, el);
        focusMethod = onblurTempEl;
        if (newEl) focusEl(newEl);
    } else {
        ogti = el.getAttribute('tabindex');
        if (ogti) el.setAttribute('data-ogti', ogti);
        focusEl(el);
    }
};
function $3725beb56f0bb89d$export$de363e709c412c8a(callbackFunction, limit) {
    let tick = false;
    return function() {
        if (!tick) {
            callbackFunction();
            tick = true;
            setTimeout(function() {
                tick = false;
            }, limit);
        }
    };
}
const $3725beb56f0bb89d$export$b1163bac65e099a = [
    'a[href]:not([tabindex^="-"])',
    'area[href]:not([tabindex^="-"])',
    'input:not([type="hidden"]):not([type="radio"]):not([disabled]):not([tabindex^="-"])',
    'input[type="radio"]:not([disabled]):not([tabindex^="-"]):checked',
    'select:not([disabled]):not([tabindex^="-"])',
    'textarea:not([disabled]):not([tabindex^="-"])',
    'button:not([disabled]):not([tabindex^="-"])',
    'iframe:not([tabindex^="-"])',
    'audio[controls]:not([tabindex^="-"])',
    'video[controls]:not([tabindex^="-"])',
    '[contenteditable]:not([tabindex^="-"])',
    '[tabindex]:not([tabindex^="-"])'
];
const $3725beb56f0bb89d$export$61319805fa787d = 'a[href]:not([tabindex^="-"]), area[href]:not([tabindex^="-"]), input:not([type="hidden"]):not([type="radio"]):not([disabled]):not([tabindex^="-"]), input[type="radio"]:not([disabled]):not([tabindex^="-"]):checked, select:not([disabled]):not([tabindex^="-"]), textarea:not([disabled]):not([tabindex^="-"]), button:not([disabled]):not([tabindex^="-"]), iframe:not([tabindex^="-"]), audio[controls]:not([tabindex^="-"]), video[controls]:not([tabindex^="-"]), [contenteditable]:not([tabindex^="-"]), [tabindex]:not([tabindex^="-"])';


function $f6437dbc0829a1ad$export$2e2bcd8739ae039() {
    document.querySelectorAll('[ck-nav-component]').forEach((component)=>{
        const nav = component.querySelector('[ck-nav]');
        if (!nav) return;
        // Setup initial ARIA attributes and roles
        const setupAriaAttributes = ()=>{
            // Setup navigation
            nav.setAttribute('role', 'navigation');
            nav.setAttribute('aria-label', 'Main navigation');
            nav.setAttribute('aria-hidden', 'true');
            // Setup menu structure
            const menuList = nav.querySelector('ul');
            if (menuList) {
                menuList.setAttribute('role', 'menubar');
                // Setup menu items
                menuList.querySelectorAll('li').forEach((li)=>{
                    li.setAttribute('role', 'none');
                    const anchor = li.querySelector('a');
                    if (anchor) {
                        anchor.setAttribute('role', 'menuitem');
                        // If no aria-label is present, use the text content
                        if (!anchor.hasAttribute('aria-label')) anchor.setAttribute('aria-label', anchor.textContent?.trim() || 'Menu item');
                    }
                });
            }
            // Setup toggle buttons
            component.querySelectorAll('[ck-nav-toggle]').forEach((toggle)=>{
                const id = toggle.getAttribute('ck-nav-toggle');
                toggle.setAttribute('aria-label', toggle.getAttribute('aria-label') || 'Toggle menu');
                toggle.setAttribute('aria-controls', id || 'site-navigation');
                toggle.setAttribute('aria-expanded', 'false');
            });
            // Setup close buttons
            component.querySelectorAll('[ck-nav-close]').forEach((close)=>{
                if (!close.hasAttribute('aria-label')) close.setAttribute('aria-label', 'Close menu');
            });
        };
        let lastFocus = null;
        let navOpen = false;
        let clickOutsideHandler = null;
        // Initialize ARIA attributes
        setupAriaAttributes();
        /**
     * Handle tab key within the navigation component to ensure that focus remains trapped.
     * @param {KeyboardEvent} e - The keydown event object.
     */ const handleTabKey = (e)=>{
            if (e.key !== 'Tab') return;
            const focusableEls = Array.from(nav.querySelectorAll((0, $3725beb56f0bb89d$export$61319805fa787d))).filter((el)=>window.getComputedStyle(el).display !== 'none');
            if (!focusableEls.length) return;
            const [firstFocusableEl, lastFocusableEl] = [
                focusableEls[0],
                focusableEls[focusableEls.length - 1]
            ];
            const isFirstElement = document.activeElement === firstFocusableEl;
            const isLastElement = document.activeElement === lastFocusableEl;
            if (e.shiftKey && isFirstElement) {
                e.preventDefault();
                lastFocusableEl.focus();
            } else if (!e.shiftKey && isLastElement) {
                e.preventDefault();
                firstFocusableEl.focus();
            }
        };
        /**
     * Handle arrow key navigation within menu items
     * @param {KeyboardEvent} e - The keydown event object.
     */ const handleArrowKeys = (e)=>{
            const menuItems = Array.from(nav.querySelectorAll('[role="menuitem"]'));
            if (!menuItems.length) return;
            const currentIndex = menuItems.indexOf(document.activeElement);
            if (currentIndex === -1) return;
            let nextIndex;
            switch(e.key){
                case 'ArrowDown':
                case 'ArrowRight':
                    e.preventDefault();
                    nextIndex = currentIndex === menuItems.length - 1 ? 0 : currentIndex + 1;
                    menuItems[nextIndex].focus();
                    break;
                case 'ArrowUp':
                case 'ArrowLeft':
                    e.preventDefault();
                    nextIndex = currentIndex === 0 ? menuItems.length - 1 : currentIndex - 1;
                    menuItems[nextIndex].focus();
                    break;
                case 'Home':
                    e.preventDefault();
                    menuItems[0].focus();
                    break;
                case 'End':
                    e.preventDefault();
                    menuItems[menuItems.length - 1].focus();
                    break;
            }
        };
        /**
     * Handler for keydown events when navigation is open.
     * @param {KeyboardEvent} e - The keydown event object.
     */ const keydownHandler = (e)=>{
            if (e.key === 'Escape') {
                e.preventDefault();
                closeNav();
            } else if (e.key === 'Tab') handleTabKey(e);
            else handleArrowKeys(e);
        };
        /**
     * Remove click outside handler
     */ const removeClickOutsideHandler = ()=>{
            if (clickOutsideHandler) {
                document.removeEventListener('click', clickOutsideHandler);
                clickOutsideHandler = null;
            }
        };
        /**
     * Close the navigation component and remove event listeners.
     */ const closeNav = ()=>{
            if (!navOpen) return;
            document.body.style.overflow = '';
            component.classList.remove('open');
            nav.setAttribute('aria-hidden', 'true');
            component.querySelectorAll('[ck-nav-toggle]').forEach((toggle)=>toggle.setAttribute('aria-expanded', 'false'));
            navOpen = false;
            document.removeEventListener('keydown', keydownHandler);
            removeClickOutsideHandler();
            if (lastFocus) setTimeout(()=>lastFocus?.focus(), 100);
        };
        /**
     * Show the navigation component and add event listeners.
     */ const showNav = ()=>{
            if (navOpen) return;
            document.body.style.overflow = 'hidden';
            component.classList.add('open');
            nav.setAttribute('aria-hidden', 'false');
            component.querySelectorAll('[ck-nav-toggle]').forEach((toggle)=>toggle.setAttribute('aria-expanded', 'true'));
            clickOutsideHandler = (e)=>{
                const target = e.target;
                if (!nav.contains(target) && !target.hasAttribute('ck-nav-toggle')) closeNav();
            };
            setTimeout(()=>{
                document.addEventListener('click', clickOutsideHandler);
            }, 100);
            document.addEventListener('keydown', keydownHandler);
            navOpen = true;
            lastFocus = document.activeElement;
            setTimeout(()=>{
                const firstMenuItem = nav.querySelector('[role="menuitem"]');
                const firstFocusable = nav.querySelector((0, $3725beb56f0bb89d$export$61319805fa787d));
                const elementToFocus = firstMenuItem || firstFocusable;
                elementToFocus?.focus();
            }, 100);
        };
        // Initialize event listeners for nav toggle buttons
        component.querySelectorAll('[ck-nav-toggle]').forEach((navbarToggle)=>{
            navbarToggle.addEventListener('click', (e)=>{
                e.stopPropagation();
                navOpen ? closeNav() : showNav();
            });
        });
        // Initialize event listeners for nav close buttons
        component.querySelectorAll('[ck-nav-close]').forEach((closeButton)=>{
            closeButton.addEventListener('click', closeNav);
        });
    });
}


console.info("%c\uD83D\uDD25CK Started!", 'color: red; font-size: 1rem;');
// accessibility enhancements
(0, $e8de77a7e14f36ab$export$2e2bcd8739ae039)();
(0, $e7f9d3ea50c2560b$export$2e2bcd8739ae039)();
(0, $f6437dbc0829a1ad$export$2e2bcd8739ae039)();

})();
//# sourceMappingURL=index.js.map
